import { Collapse, Row, Col, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  dineroDisabledMask,
  ModalItem,
  ButtonItem,
} from "../../../../Components/Items";
import moment from "moment";
import CancelarPago from "../CancelarPago/CancelarPago";
// import CancelarPago from "../CancelarPago/CancelarPago";

const { Panel } = Collapse;

class PagosRemision extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pagosHtml: <p>No se encontro ningun pago</p>,
    modalCancelarPago: false,
    modalCancelarPagoId: null
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "pagos/pagosRemision",
        { remisionId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) return;
        const html = (
          <Collapse style={{ marginBottom: 10 }}>
            {res.data.map((valuePago) => {
              return (
                <Panel
                  extra={
                    valuePago.estado !== 0 ? (
                      valuePago.moneda.abreviacion+' - '+dineroDisabledMask(valuePago.monto)
                    ) : (
                      <Tag color="red">
                        Cancelada: {valuePago.moneda.abreviacion+' - '+dineroDisabledMask(valuePago.monto)}
                      </Tag>
                    )
                  }
                  header={moment(valuePago.fechaPago).locale("es").format("ll")}
                  key={valuePago._id}
                >
                  <Row>
                    <Col span={12}>
                      <p>
                        Dia del Pago:{" "}
                        {moment(valuePago.fechaPago).locale("es").format("ll")}
                      </p>
                      <p>
                        Complemento de Pago:{" "}
                        {valuePago.complemento ? "Si" : "No"}
                      </p>
                      <p>
                        Nota de credito:{" "}
                        {valuePago.notaDeCreditoId ? "Si" : "No"}
                      </p>
                    </Col>
                    <Col span={12}>
                      <p>
                        Dia de registro:{" "}
                        {moment(valuePago.createdAt).locale("es").format("ll")}
                      </p>
                      <p>Monto: {valuePago.moneda.abreviacion+' - '+dineroDisabledMask(valuePago.monto)}</p>
                      {valuePago?.banco?.banco && <p>Banco: {valuePago?.banco?.banco}</p>}
                      {valuePago.estado !== 0 && !valuePago.contado && !valuePago.pagarFactura && (
                        <ButtonItem type="primary" danger onClick={() => {
                          this.setState({modalCancelarPago: true, modalCancelarPagoId: valuePago._id})
                        }}>
                          Cancelar Pago
                        </ButtonItem>
                      )}
                    </Col>
                  </Row>
                </Panel>
              );
            })}
          </Collapse>
        );
        this.setState({ pagosHtml: html });
      });
    this.setState({ loading: false });
  }
  cerrarPagosRemision() {
    this.props.cerrarPagosRemision();
  }
  cerrarCancelarPago() {
    this.setState({
      modalCancelarPago: false,
      modalCancelarPagoId: null,
    });
    this.consultarTodo()
  }
  render() {
    return (
      <>
      <ModalItem
        title="Pagos Remisión"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarPagosRemision.bind(this)}
        paddingTop
      >
        {this.state.pagosHtml}
      </ModalItem>
      <CancelarPago
          visible={this.state.modalCancelarPago}
          id={this.state.modalCancelarPagoId}
          cerrarCancelarPago={this.cerrarCancelarPago.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(PagosRemision);
